import i18next from "src/i18n/config";

import { Theme } from "@mui/material";
import { StatusTone } from "@shared/StatusLabel";

export const getSubscriptionStatusLabel = (status: string) => {
    switch (status.trim().toLowerCase()) {
        case "active":
            return i18next.t("common:status.active");
        case "cancelled":
            return i18next.t("common:status.cancelled");
        case "expired":
            return i18next.t("common:status.expired");
        case "terminated":
            return i18next.t("common:status.terminated");
        default:
            return status;
    }
};

/**
 * Tone of a subscription's `StatusLabel`. Keep it in line with the colours of `getStatusIndicatorData`, which draws
 * the same status as a dot in the client panel's header.
 */
export const getSubscriptionStatusTone = (status: string): StatusTone => {
    switch (status.trim().toLowerCase()) {
        case "active":
            return "positive";
        case "cancelled":
            return "warning";
        case "expired":
            return "error";
        default:
            return "neutral";
    }
};

export const getStatusIndicatorData = (status: string, theme: Theme) => {
    const normalizedStatus = status.trim().toLowerCase();

    switch (normalizedStatus) {
        case "active":
            return {
                tooltip: getSubscriptionStatusLabel(status),
                color: theme.palette.emteria.success,
            };
        case "cancelled":
            return {
                tooltip: getSubscriptionStatusLabel(status),
                color: theme.palette.emteria.warning,
            };
        case "expired":
            return {
                tooltip: getSubscriptionStatusLabel(status),
                color: theme.palette.emteria.error,
            };
        case "terminated":
            return {
                tooltip: getSubscriptionStatusLabel(status),
                color: theme.palette.emteria.background.disabled,
            };
        default:
            return {
                tooltip: i18next.t("pages:clientsOverviewPage.table.tooltip.unknownStatus"),
                color: theme.palette.emteria.text.secondary,
            };
    }
};
